import { Option } from 'src/types/form'
import { ListRegionForFormType } from 'src/types/region'

export const buildRegionOptions = (
  regions?: ListRegionForFormType[],
  nullOption: Option = {
    label: 'Where trees are needed most',
    value: 'choose_for_me'
  }
): Option[] => {
  const options =
    regions?.reduce((arr: Option[], region: ListRegionForFormType) => {
      let label = region.ProperSpelling || region.Name
      if (region.AltName) label += ` - ${region.AltName}`

      return [
        ...arr,
        {
          label,
          value: region.Id
        }
      ]
    }, []) || []

  const sortedOptions = options.sort((a: Option, b: Option) =>
    (a.label as string).localeCompare(b.label as string)
  )

  sortedOptions.unshift(nullOption)

  return sortedOptions
}

/**
 * Builds region filter options for FilterControls component
 * Uses id/name format instead of label/value
 */
export const buildRegionFilterOptions = (
  regions?: Array<{
    Id: string
    Name: string
    ProperSpelling?: string | null
    AltName?: string | null
  }>
): Array<{ id: string; name: string }> => {
  return (
    regions
      ?.map(r => {
        let name = r.ProperSpelling || r.Name
        if (r.AltName) name += ` - ${r.AltName}`
        return {
          id: r.Id,
          name
        }
      })
      .sort((a, b) => a.name.localeCompare(b.name)) || []
  )
}
